import React from 'react'

export default function GrayPull (props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' style={props.style} onClick={props.onClick} t='1569306586663' viewBox='0 0 1024 1024' version='1.1' p-id='6560' width={props.width || 20} height={props.height || 20}><defs><style type='text/css' /></defs><path d='M512 192c-176.7 0-320 143.3-320 320s143.3 320 320 320 320-143.3 320-320-143.3-320-320-320z m181 280.2L534.6 630.6c-12.5 12.5-32.8 12.5-45.3 0L331 472.2c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L512 562.7 647.8 427c12.5-12.5 32.8-12.5 45.3 0 12.4 12.5 12.4 32.7-0.1 45.2z' fill='' p-id='6561' /></svg>
  )
}
